import { Alert, AlertTitle, Divider, Grid, Typography } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { AddressAPI } from "../../../api";
import { useGlobalOrganizationContext } from "../../../hooks/useGlobalOrganizationContext";
import eventEmitter from "../../../lib/event";
import { OrganizationAddressLabels } from "../../../model/Address";
import ManageAddress from "../components/ManageAddress";
import { useUpdateOrganizationProps } from "../components/UpdateOrganizationContext";

const OrganizationAddressSettings: FC<unknown> = () => {
  const { organization } = useUpdateOrganizationProps();
  const { organizationBillingState } = useGlobalOrganizationContext();

  const [
    organizationBillingAddressWarning,
    setOrganizationBillingAddressWarning,
  ] = useState<boolean>(false);

  const [refreshState, setRefreshState] = useState<number>(0);

  useEffect(() => {
    eventEmitter.on("address:refresh", () => {
      setRefreshState((prev) => prev + 1);
    });

    return () => {
      eventEmitter.off("address:refresh");
    };
  }, []);

  useEffect(() => {
    if (!organization) {
      setOrganizationBillingAddressWarning(false);
      return;
    }
    if (!organizationBillingState || !organizationBillingState.stripe_id) {
      setOrganizationBillingAddressWarning(false);
      return;
    }

    AddressAPI.getOrganizationAddressEntriesByLabel(
      organization.id,
      OrganizationAddressLabels.BILLING,
    ).then((result) => {
      if (result.length == 0) {
        setOrganizationBillingAddressWarning(true);
      } else {
        setOrganizationBillingAddressWarning(false);
      }
    });
  }, [organization, organizationBillingState, refreshState]);

  if (organization)
    return (
      <Grid container direction={"column"}>
        <Grid>
          <Typography variant="h1" pb={1}>
            Organization Addresses
          </Typography>
        </Grid>
        {organizationBillingAddressWarning && (
          <Grid>
            <Alert
              severity="warning"
              sx={{
                minWidth: "25vw",
                width: "50%",
              }}
            >
              <AlertTitle>Billing Address Not Set</AlertTitle>
              This organization does not have a billing address set, which is
              necessary for billing through Stripe.
            </Alert>
          </Grid>
        )}

        <Grid
          container
          borderRadius={"10px"}
          overflow={"hidden"}
          border={"1px solid #aaaaaa"}
          spacing={0}
          boxShadow={"0px 1px 2px #aaaaaa"}
        >
          <Grid size={12}>
            <ManageAddress
              label={OrganizationAddressLabels.PRIMARY}
              organization={organization}
              customBlankText="No primary address!"
            />
          </Grid>

          <Grid size={12}>
            <Divider />
          </Grid>

          <Grid size={12}>
            <ManageAddress
              label={OrganizationAddressLabels.BILLING}
              organization={organization}
              customBlankText="No billing address!"
              showStripeSync={
                organizationBillingState?.stripe_id ? true : false
              }
            />
          </Grid>
        </Grid>
      </Grid>
    );
};

export { OrganizationAddressSettings };
